"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.WrappedLoginForm = void 0;
var _react = _interopRequireDefault(require("react"));
var _CornerstoneForm = _interopRequireDefault(require("cornerstone_ui_core/lib/components/CornerstoneForm"));
var _CornerstoneRow = _interopRequireDefault(require("cornerstone_ui_core/lib/components/CornerstoneRow"));
var _CornerstoneCol = _interopRequireDefault(require("cornerstone_ui_core/lib/components/CornerstoneCol"));
var _CornerstoneLoader = _interopRequireDefault(require("cornerstone_ui_core/lib/components/CornerstoneLoader"));
var _CornerstoneIcon = _interopRequireDefault(require("cornerstone_ui_core/lib/components/CornerstoneIcon"));
var _CornerstoneButton = _interopRequireDefault(require("cornerstone_ui_core/lib/components/CornerstoneButton"));
var _PromiseModalHOC = _interopRequireDefault(require("cornerstone_ui_core/lib/components/PromiseModalHOC"));
var _CornerstoneInput = require("cornerstone_ui_core/lib/components/CornerstoneInput");
var _utils = require("cornerstone_ui_core/lib/utils");
var _baseLayout = require("cornerstone_ui_core/lib/containers/BaseLayout/base-layout.service");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const {
  TextArea
} = _CornerstoneInput.Input;
const defaultFields = {
  userName: true,
  passWord: true,
  comments: true
};
function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}
class Login extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "handleSubmit", e => {
      e.preventDefault();
      this.props.form.validateFields(async (err, values) => {
        if (!err) {
          this.setState({
            loading: true
          });
          try {
            const res = await (0, _baseLayout.performEsignAuth)({
              userName: this.props.userId,
              passWord: values.passWord
            });
            if (res && res.performEsignAuth) {
              let userDetails = await (0, _baseLayout.findByUserApps)(this.props.userId);
              const appName = (0, _utils.getAppName)();
              const key = userDetails.roles.filter(role => {
                return role.appName === appName;
              });
              localStorage.setItem("jwttknkey", key[0].jwtCacheKey);
              localStorage.setItem("jwtToken", key[0].jwtToken);
              this.props.onSuccess(values);
            } else {
              this.setState({
                loading: false
              });
              this.setState({
                authError: "Authentication failed"
              });
            }
          } catch (err) {
            this.setState({
              loading: false
            });
          }
        }
      });
    });
    this.state = {
      authError: ""
    };
  }
  componentDidMount() {
    // To disable submit button at the beginning.
    this.props.form.validateFields();
  }
  render() {
    const {
      fields,
      form,
      eSignOf
    } = this.props;
    const comments = this.props.formulaSpecificationLevel && this.props.formulaSpecificationLevel.comments || this.props.electronicBatchAction;
    const {
      getFieldDecorator,
      getFieldsError,
      getFieldError,
      isFieldTouched
    } = form;
    const visibleFields = {
      ...defaultFields,
      ...fields
    };
    // Only show error after a field is touched.
    const userNameError = isFieldTouched("userName") && getFieldError("userName");
    const passWordError = isFieldTouched("passWord") && getFieldError("passWord");
    const commentError = isFieldTouched("comments") && getFieldError("comments");
    return /*#__PURE__*/_react.default.createElement(_CornerstoneForm.default, {
      onKeyDown: e => this.setState({
        isCapsLock: e.getModifierState("CapsLock")
      }),
      onSubmit: this.handleSubmit
    }, this.state.loading && /*#__PURE__*/_react.default.createElement(_CornerstoneLoader.default, null), /*#__PURE__*/_react.default.createElement(_CornerstoneRow.default, {
      gutter: {
        xs: 8,
        sm: 16,
        md: 24,
        lg: 32
      }
    }, /*#__PURE__*/_react.default.createElement(_CornerstoneCol.default, {
      span: 24
    }, /*#__PURE__*/_react.default.createElement(_CornerstoneForm.default.Item, {
      colon: false,
      validateStatus: this.state.authError ? "error" : "",
      help: userNameError || ""
    }, this.state.authError || "You have been logged out. Please login to continue.")), visibleFields.userName && /*#__PURE__*/_react.default.createElement(_CornerstoneCol.default, {
      span: 12
    }, /*#__PURE__*/_react.default.createElement(_CornerstoneForm.default.Item, {
      colon: false,
      label: "Username"
    }, /*#__PURE__*/_react.default.createElement(_CornerstoneInput.Input, {
      prefix: /*#__PURE__*/_react.default.createElement(_CornerstoneIcon.default, {
        type: "user",
        style: {
          color: "rgba(0,0,0,.25)"
        }
      }),
      disabled: true,
      value: this.props.userId
    }))), visibleFields.passWord && /*#__PURE__*/_react.default.createElement(_CornerstoneCol.default, {
      span: 12
    }, /*#__PURE__*/_react.default.createElement(_CornerstoneForm.default.Item, {
      colon: false,
      label: "Password",
      validateStatus: passWordError ? "error" : "",
      help: passWordError || ""
    }, getFieldDecorator("passWord", {
      rules: [{
        required: true,
        message: "Please input your password"
      }]
    })( /*#__PURE__*/_react.default.createElement(_CornerstoneInput.Input, {
      prefix: /*#__PURE__*/_react.default.createElement(_CornerstoneIcon.default, {
        type: "lock",
        style: {
          color: "rgba(0,0,0,.25)"
        }
      }),
      type: "passWord",
      autoComplete: "off"
      //placeholder="Password"
    }))))), this.state.isCapsLock && /*#__PURE__*/_react.default.createElement("div", {
      style: {
        textAlign: "right",
        color: "red"
      }
    }, "Caps lock is on"), comments && visibleFields.comments && /*#__PURE__*/_react.default.createElement(_CornerstoneRow.default, {
      gutter: {
        xs: 8,
        sm: 16,
        md: 24,
        lg: 32
      }
    }, /*#__PURE__*/_react.default.createElement(_CornerstoneCol.default, {
      span: 24
    }, /*#__PURE__*/_react.default.createElement(_CornerstoneForm.default.Item, {
      colon: false,
      label: "Comments",
      validateStatus: commentError ? "error" : "",
      help: commentError || ""
    }, getFieldDecorator("comments", {
      rules: [{
        required: true,
        message: "Please input your comments"
      }]
    })( /*#__PURE__*/_react.default.createElement(TextArea, {
      rows: 4,
      placeholder: "Comments"
    }))))), /*#__PURE__*/_react.default.createElement(_CornerstoneForm.default.Item, null, /*#__PURE__*/_react.default.createElement(_CornerstoneButton.default, {
      type: "primary",
      htmlType: "submit",
      disabled: hasErrors(getFieldsError())
    }, "Login")));
  }
}
_defineProperty(Login, "defaultProps", {
  fields: defaultFields
});
const WrappedLoginForm = exports.WrappedLoginForm = _CornerstoneForm.default.create({
  name: "login"
})(Login);
var _default = exports.default = (0, _PromiseModalHOC.default)(WrappedLoginForm);